export default "__VITE_ASSET__3UIbKsp8__"